/**
 * @module businessComponents\mdl\structureNavigation
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model, Watch } from "vue-property-decorator";
import GhInvoke from "@/components/ghInvoke/ghInvoke";

@Component
export default class StructureNavigation extends Vue {
  @Model("change")
  private value!: object;

  @Prop()
  private dataSource!: any;

  @Prop({ default: true })
  private showToolbar!: any;

  @Prop({ default: "-1" })
  private parentId!: string;

  @Prop({ default: "" })
  private level!: string;

  @Prop({ default: "" })
  private func!: string;

  @Prop({ default: true })
  private cascade!: boolean;

  @Prop({ default: false })
  private attachedAll!: boolean;

  private data = [];

  private currentNode = null;

  @Watch("currentNode")
  private observe() {
    this.$emit("change", this.currentNode);
  }

  @Watch("data")
  private observeData() {
    if (this.data) {
      this.$emit("update:dataSource", this.data);
    }
  }

  private get args() {
    let arg = {
      parent_id: this.parentId,
      level: this.level,
      func: this.func,
      cascade: this.cascade,
      attached_all: this.attachedAll
    };
    return arg;
  }

  private get inv(): GhInvoke {
    return this.$refs.inv as GhInvoke;
  }

  @Watch("args")
  public query() {
    if (this.inv) {
      this.inv.invoke(this.args);
    }
  }

 
}
